import React from 'react';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { MenuProps } from 'antd/lib/menu';
import SubMenu from 'antd/es/menu/SubMenu';

const { Sider: AntdSider } = Layout;

interface MenuItem {
  name: string
  path?: string
  icon?: React.ReactNode
  children?: MenuItem[]
}

interface SiderProps {
  items: MenuItem[];
}


const SideBar: React.FC<SiderProps> = ({ items, ...menuProps }) => {
  return (
    <AntdSider
      breakpoint="lg"
      collapsedWidth="0"
      onBreakpoint={(broken) => {
        console.log(broken);
      }}
      onCollapse={(collapsed, type) => {
        console.log(collapsed, type);
      }}
    >
      <Menu
        mode="inline"
        defaultSelectedKeys={['0']}
        defaultOpenKeys={['sub1']}
        style={{ height: '100%', borderRight: 0 }}
        {...menuProps}
      >
        {items.map((item, index) => {

          if (item?.children?.length) {
            return (
              <SubMenu key={`sub_${index}`} title={item.name} icon={item.icon}>
                {item.children.map((childItem: any) => (
                  <Menu.Item key={childItem.path} icon={childItem.icon}>
                    <Link to={childItem.path}>{childItem.name}</Link>
                  </Menu.Item>
                ))}
              </SubMenu>
            );
          }

          return (
            <Menu.Item key={item.path} icon={item.icon}>
              <Link to={`${item.path}`}>{item.name}</Link>
            </Menu.Item>
          )
        })}
      </Menu>
    </AntdSider>
  );
};

export default SideBar;